import {Directive, ElementRef, HostListener, Output, Input, OnChanges, EventEmitter, SimpleChanges} from '@angular/core';

import {Debounced, Throttle} from '../utils/throttle';

/**
 * 函数防抖指令
 * 事件被触发，n秒后执行一次函数，如果n秒内再次被触发，就重新计算时间
 *
 * 例如：<button nz-button nzType="primary" nzSize="small" Debounced (debouncedClick)="downloadFile(data)">下载</button>
 */

@Directive({
  selector: '[Debounced]'
})

export class DebouncedDirective implements OnChanges {

  constructor(
    private el: ElementRef,
  ) {
  }

  @Input() delay = 1000;

  @Output() debouncedClick = new EventEmitter<any>();

  private debouncedUse = new Debounced().use(this.Click, this, this.delay, true);

  // 监听输入值变化
  ngOnChanges(changes: SimpleChanges): any {
    if (changes.delay && changes.delay.currentValue) {
      this.debouncedUse = new Debounced().use(this.Click, this, this.delay, true);
    }
  }

  @HostListener('click', ['$event']) onClick(event): void {
    const params = {
      element: this.el,
      event
    };
    this.debouncedUse(params);
  }

  private Click(params): void {
    this.debouncedClick.next(params);
  }

}
